import {
  Companion_instance2aoezwcxpm6pa as Companion_instance,
  Basic3vvjt6j04wm3x as Basic,
} from './shared.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareBasicFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Basic_title_getInstance(), Basic_body_getInstance(), Basic_url_getInstance()];
  var tmp = Companion_instance.m2a();
  properties(tmp, (it) => props);
}
function Basic_title$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(0);
}
function Basic_title$_get_name_$ref_ur9o5w() {
  return (p0) => p0.k20();
}
function Basic_title$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Basic_title$_get_serializer_$ref_a8cksl() {
  return (p0) => p0.j2j();
}
function Basic_title$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(0);
}
function Basic_title$_get_annotations_$ref_gyom73() {
  return (p0) => p0.bz();
}
var Basic_titleClass;
function Basic_title() {
  if (Basic_titleClass === VOID) {
    class $ {
      constructor() {
        Basic_title_instance = this;
        var tmp = this;
        tmp.m8i_1 = lazy(Basic_title$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n8i_1 = lazy(Basic_title$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o8i_1 = lazy(Basic_title$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.m8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Basic_title$_get_name_$ref_ur9o5w(), null);
        return tmp0.f2();
      }
      p8i(receiver) {
        return receiver.q8i_1;
      }
      m2j(receiver) {
        return this.p8i(receiver instanceof Basic() ? receiver : THROW_CCE());
      }
      t8i(receiver, value) {
        return receiver.u8i(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Basic() ? receiver : THROW_CCE();
        return this.t8i(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Basic_title$_get_serializer_$ref_a8cksl(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Basic_title$_get_annotations_$ref_gyom73(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Basic_title', VOID, VOID, [SerializableProperty()]);
    Basic_titleClass = $;
  }
  return Basic_titleClass;
}
var Basic_title_instance;
function Basic_title_getInstance() {
  if (Basic_title_instance === VOID)
    new (Basic_title())();
  return Basic_title_instance;
}
function Basic_body$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(1);
}
function Basic_body$_get_name_$ref_hqjdeo() {
  return (p0) => p0.k20();
}
function Basic_body$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Basic_body$_get_serializer_$ref_7stfg9() {
  return (p0) => p0.j2j();
}
function Basic_body$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(1);
}
function Basic_body$_get_annotations_$ref_cmb2jv() {
  return (p0) => p0.bz();
}
var Basic_bodyClass;
function Basic_body() {
  if (Basic_bodyClass === VOID) {
    class $ {
      constructor() {
        Basic_body_instance = this;
        var tmp = this;
        tmp.v8i_1 = lazy(Basic_body$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w8i_1 = lazy(Basic_body$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x8i_1 = lazy(Basic_body$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.v8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Basic_body$_get_name_$ref_hqjdeo(), null);
        return tmp0.f2();
      }
      p8i(receiver) {
        return receiver.r8i_1;
      }
      m2j(receiver) {
        return this.p8i(receiver instanceof Basic() ? receiver : THROW_CCE());
      }
      t8i(receiver, value) {
        return receiver.u8i(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Basic() ? receiver : THROW_CCE();
        return this.t8i(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Basic_body$_get_serializer_$ref_7stfg9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Basic_body$_get_annotations_$ref_cmb2jv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Basic_body', VOID, VOID, [SerializableProperty()]);
    Basic_bodyClass = $;
  }
  return Basic_bodyClass;
}
var Basic_body_instance;
function Basic_body_getInstance() {
  if (Basic_body_instance === VOID)
    new (Basic_body())();
  return Basic_body_instance;
}
function Basic_url$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(2);
}
function Basic_url$_get_name_$ref_h2wrij() {
  return (p0) => p0.k20();
}
function Basic_url$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Basic_url$_get_serializer_$ref_6rz7wu() {
  return (p0) => p0.j2j();
}
function Basic_url$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(2);
}
function Basic_url$_get_annotations_$ref_j3pf62() {
  return (p0) => p0.bz();
}
var Basic_urlClass;
function Basic_url() {
  if (Basic_urlClass === VOID) {
    class $ {
      constructor() {
        Basic_url_instance = this;
        var tmp = this;
        tmp.y8i_1 = lazy(Basic_url$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z8i_1 = lazy(Basic_url$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a8j_1 = lazy(Basic_url$annotations$delegate$lambda);
        this.b8j_1 = null;
        this.c8j_1 = 'null';
      }
      k20() {
        var tmp0 = this.y8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Basic_url$_get_name_$ref_h2wrij(), null);
        return tmp0.f2();
      }
      p8i(receiver) {
        return receiver.s8i_1;
      }
      m2j(receiver) {
        return this.p8i(receiver instanceof Basic() ? receiver : THROW_CCE());
      }
      d8j(receiver, value) {
        return receiver.u8i(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Basic() ? receiver : THROW_CCE();
        return this.d8j(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Basic_url$_get_serializer_$ref_6rz7wu(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Basic_url$_get_annotations_$ref_j3pf62(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Basic_url', VOID, VOID, [SerializableProperty()]);
    Basic_urlClass = $;
  }
  return Basic_urlClass;
}
var Basic_url_instance;
function Basic_url_getInstance() {
  if (Basic_url_instance === VOID)
    new (Basic_url())();
  return Basic_url_instance;
}
//region block: exports
export {
  prepareBasicFields as prepareBasicFieldsni689atozb9s,
};
//endregion

//# sourceMappingURL=BasicFields.mjs.map
